/**
 * 不能保存函数，建议funcname.toString() 后保存
 * 保存时，如果没有给value， 不会报错，
 * 但取值时，如果为undefined，会提示
 * 保存的类型为 Symbol 时，无法正常保存
 * 不提供遍历的方法，可以使用原生
 */
/**
 * localData 可以在构造的时候给个选项
 * localStorage 或者 sessionStorage
 * 就可以实现存储方式的改变
 */
/**
 * 保存数据到本地
 * 这里写成函数的形式
 * 是为了私有变量
 * @author 屠佳伟 Mrprince 2019-09-28
 * @param prefix 保存键值对的前缀，避免冲突
 *
 *
 * !!! 需要注意的是，不能保存函数到本地
 * 需要将函数装换成字符串再保存
 */
// TODO 添加过期
class LocalData {
    /**
     * @param prefix - key前缀
     */
    constructor(prefix = 'tujiawei') {
        this.prefix = prefix;
    }
    /**
     * 获取对应值的字符串
     *
     * @param key - 属性
     */
    getString(key) {
        return localStorage.getItem(this.prefix + key);
    }
    /**
     * 获取对应值
     *
     */
    get(key) {
        let res = this.getString(key);
        try {
            return JSON.parse(res);
        }
        catch (e) {
            console.warn('无法转换');
        }
        return res;
    }
    /**
     * @param key
     * @param value
     */
    set(key, value) {
        localStorage.setItem(this.prefix + key, JSON.stringify(value));
    }
    /**
     * 清空
     */
    clear() {
        localStorage.clear();
    }
    /**
     * 移除
     *
     * @param key
     */
    remove(key) {
        localStorage.removeItem(this.prefix + key);
    }
}
export default LocalData;
//# sourceMappingURL=data:application/json;base64,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